import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { ObjectEdit } from '../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit';
import ObjectsPage from '../../../../_metronic/layout/components/basePage/pages/ObjectsPage';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import {
  formFields,
  otherFields,
  initObject,
  ObjectEditSchema,
  columns,
  prepareFilter,
  filterFields,
  filterInitialValues,
} from "./AuditPeriodUtils";
import { FormTypeAccessPage } from "./FormTypeAccessPage";
import { AuditPlaceAccessPage } from "./AuditPlaceAccessPage";

const AuditPeriodPage = () => {
  const { currentState } = useSelector(
    (state) => ({ currentState: state.auditPeriods }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find((q) => q.url == "/audit")) {
    const temp = menuList.find((q) => q.url == "/audit");
    isFullAccess = temp.isFullAccess;
  }

  const otherTabs = [
    { id: 2, title: "پرسشنامه  های مجاز", tab: 'auditFormType', component: FormTypeAccessPage },
    { id: 3, title: "MODULES.BASEINFO.ROLE.PERMISSION_PLACE", tab: 'auditPlace', component: AuditPlaceAccessPage },
    // { id: 3, title: "پرسشنامه  های مجاز", tab: 'formAccess'},
    // { id: 4, title: "MODULES.BASEINFO.ROLE.PERMISSION_SELF_TYPE", tab: 'selfTypeAccess'},
    // { id: 4, title: "MODULES.BASEINFO.ROLE.PERMISSION_ROLE", tab: 'roleAccess',component:RoleAccessPage},
    // { id: 5, title: "MODULES.BASEINFO.ROLE.PERMISSION_MENU", tab: 'menuAccess',component:MenuAccessPage},
  ];

  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>

          <ContentRoute path="/audit/new"
            render={props =>
              <ObjectEdit {...props} isFullAccess={isFullAccess} basePath="/audit" api="api/AuditPeriod" currentState={currentState} initObject={initObject}
                formFields={formFields} otherFields={otherFields} ObjectEditSchema={ObjectEditSchema} prepareFilter={prepareFilter} />}
          />

          <ContentRoute
            path="/audit/:id/edit"
            render={props =>
              <ObjectEdit {...props} isFullAccess={isFullAccess} basePath="/audit" api="api/AuditPeriod" currentState={currentState} initObject={initObject}
                formFields={formFields} otherFields={otherFields} ObjectEditSchema={ObjectEditSchema} prepareFilter={prepareFilter} otherTabs={otherTabs} />}
          />

          <ContentRoute
            path="/audit"
            render={props => <ObjectsPage isFullAccess={isFullAccess} basePath="/audit" api="api/AuditPeriod" currentState={currentState}
              columns={columns} prepareFilter={prepareFilter} filterFields={filterFields} filterInitialValues={filterInitialValues} />}
          />

        </Switch>
      </Suspense>
    </FilterObjectsUIProvider>
  )
}

export default AuditPeriodPage

